module.exports = __webpack_public_path__ + "img/logo-pk-white.26e11702.png";